"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GAP_BETWEEN_SECTIONS = void 0;
exports.scrollToElement = scrollToElement;
var _topArea = require("@ori/top-area");
const GAP_BETWEEN_SECTIONS = exports.GAP_BETWEEN_SECTIONS = 20;
function scrollToElement(elementRef, isMobile = false) {
  if (!elementRef.current) {
    return;
  }
  const scrollOffset = (isMobile ? _topArea.MOBILE_WITH_TOP_AREA_BANNER_HEIGHT : _topArea.DESKTOP_WITH_TOP_AREA_BANNER_HEIGHT) + GAP_BETWEEN_SECTIONS;
  window.scrollTo({
    behavior: 'smooth',
    top: elementRef.current.offsetTop - scrollOffset
  });
}